import { DateType } from "../data/types/index";
import i18n from "@/i18n";

/**
 * Парсинг даты
 * @param src Дата в произвольном формате
 * @param defaultValue Значение по умолчанию
 */
export function parseDate(src: any, defaultValue: DateType = null): DateType {
  let date: DateType = defaultValue;
  try {
    if (!src) date = defaultValue;
    else if (!/^\/Date\(\d{1,13}\)\/$/.test(src.toString())) {
      if (src.includes('-'))
        date = new Date(src.split('-').join('/'));
      else if (src.includes('.'))
        date = new Date(src.split('.').join('/'));
    } else {
      const re = /-?\d+/;
      const tempDate = re.exec(src);
      if (tempDate) date = new Date(parseInt(tempDate[0]));
    }
  } catch {
    date = defaultValue;
  }

  return date;
}

/**
 * Авто-корректировка даты под C# стандарт
 * @date Исходная дата.
 * @return Дата формата /Date(здесь дата в милисекундах)/.
 */
export function dateToDefaultFormat(date: any): string {
  let result = null;
  if (date) {
    if (date.substr(0, 1) !== '/') {
      result = `/Date(${new Date(date).getTime()})/`;
    } else
      result = date;
  }
  return result;
}

/**
 * Приведение текстовое к виду Family
 * @param src Исходная строка.
 * @returns Отформатированная.
 */
export function correctFIO(src: string): string {
  if (src.trim() === "") return "";
  if (src.length == 1) return src.toUpperCase();
  return src.substring(0, 1).toUpperCase() + src.substring(1).toLowerCase();
}

/**Заменить текстовые валюты в строке на символ */
export function replaceCurrencySymb(value: string): string {

  if (!value)
    return '';

  value = value.replace("RUR", "₽");
  value = value.replace("USD", "$");
  value = value.replace("EUR", "€");
  value = value.replace("CNY", "￥");
  value = value.replace("CHF", "₣");

  return value;
}

/**
 * Получаем дату в американском формате
 * @param date Дата в европейском формате
 * @returns Дата в американском формате
 */
export function getAmericanDate(date: string | null): string {
  if (!date) return "";
  const day = date.substr(0, 2);
  const month = date.substr(3, 2);
  const year = date.substr(6, 4);
  return `${year}-${month}-${day}`;
}

/**
 * Получаем дату в американском формате
 * @param date Дата в европейском формате
 * @returns Дата в американском формате
 */
export function parseAmericanDate(date: string | null): Date | null {
  if (!date) return null;
  const day = parseInt(date.substr(8, 2));
  const month = parseInt(date.substr(5, 2));
  const year = parseInt(date.substr(0, 4));
  return new Date(year, month - 1, day);
}

/**
 * Строковые форматы даты. // TODO: Устаревший метод, нужно приводить к формату Date то что с сервака приходит
 * @date Исходная дата
 * @format Формат даты
 * @returns Дата в выбранном формате.
 */
export function dateFormat(date: any, format: string = "datetime"): any {
  if (!format) format = "datetime";

  if (date == null || date == undefined) return "-";

  if (/^\d{1,2}\.\d{1,2}\.\d{1,4}$/.test(date)) {
    date = date.replace(/\./g, "-");
    return date;
  }

  const re = /-?\d+/;
  let m: any = null;
  try {
    m = re.exec(date);
  } catch (e) {
    m = Date.parse(date);
  }

  if (m == null) return date;

  if (format == "timestamp") return parseInt(m[0]);

  const d = new Date(parseInt(m[0]));

  const month =
    d.getMonth() + 1 > 9 ? d.getMonth() + 1 : "0" + (1 + d.getMonth());
  const monthA: any = i18n.t("common.genitiveMonths");
  const monthB: any = i18n.t("common.months");

  if (format == "datetime")
    return (
      (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) +
      "-" +
      month +
      "-" +
      d.getFullYear() +
      " " +
      (d.getHours() > 9 ? d.getHours() : "0" + d.getHours()) +
      ":" +
      (d.getMinutes() > 9 ? d.getMinutes() : "0" + d.getMinutes())
    );
  else if (format == "date")
    return (
      (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) +
      "-" +
      month +
      "-" +
      d.getFullYear()
    );
  else if (format == "daterev")
    return (
      d.getFullYear() +
      "-" +
      month +
      "-" +
      (d.getDate() > 9 ? d.getDate() : "0" + d.getDate())
    );
  else if (format == "time")
    return (
      (d.getHours() > 9 ? d.getHours() : "0" + d.getHours()) +
      ":" +
      (d.getMinutes() > 9 ? d.getMinutes() : "0" + d.getMinutes())
    );
  else if (format == "rudata")
    return (
      (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) +
      " " +
      monthA[d.getMonth()]
    );
  else if (format == "rudatafull")
    return (
      (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) +
      " " +
      monthA[d.getMonth()] +
      " " +
      d.getFullYear()
    );
  else if (format == "rumy")
    return monthB[d.getMonth()] + " " + d.getFullYear();
  else if (format == "dateext")
    return (
      (d.getDate() > 9 ? d.getDate() : "0" + d.getDate()) +
      "." +
      month +
      "." +
      d.getFullYear()
    );
}
